define('views/pages/trade/request/navbar',[
    'jquery',
    'underscore',
    'views/base/view',
    'text!templates/pages/trade/request/navbar.ejs',
    'views/dialog'
], function($, _, View, template, Dialog) {
    'use strict';

    /*
        TRADE REQUEST NAVBAR
    */

    var TradeRequestNavbarView = View.extend({
        region: 'trade-request-navbar',
        autoRender: true,
        className: 'navbar-inner',
        template: template,
        listen: {
            'change:filterStatus_requested model': 'render',
            'change:filterStatus_processing model': 'render',
            'change:filterStatus_declined model': 'render',
            'change:filterStatus_check model': 'render',
            'change:filterStatus_ok model': 'render',
            'change:filterStatus_confirmed model': 'render',

            'change:filterType_om model': 'render',
            'change:filterType_on model': 'render',
            'change:filterType_fo model': 'render',
            'change:filterType_so model': 'render',

            'change:canDelete model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);

            var model = this.model;

            function filterClick(name) {
                return function (ev) {
                    ev.preventDefault();
                    var value = name + '_' + $(ev.currentTarget).data(name);
                    model.set(value, !model.get(value));
                };
            }

            this.delegate('click', 'a[data-filter-type]', filterClick('filterType'));
            this.delegate('click', 'a[data-filter-status]', filterClick('filterStatus'));
            this.delegate('click', '#trade-request-delete-button', this.deleteRequest);
        },
        render: function() {
            this.destroyTooltip();

            View.prototype.render.apply(this, arguments);

            this.$('#trade-request-type a').tooltip({ container: 'body', placement: 'bottom' });
        },
        destroyTooltip: function() {
            this.$('#trade-request-type a').tooltip('destroy');
        },
        deleteRequest: function() {
            var _this = this;
            Dialog
                .show('Удаление всего заказа', 'Вы действительно хотите удалить все позиции из заказа?', Dialog.Buttons.YesNo)
                .attach(this)
                .submit(function() {
                    _this.model.destroy({ wait: true }).complete(function(xhr, status) {
                        if (status === 'success') {
                            _this.model.items.reset();
                        } else {
                            if (xhr.responseJSON && xhr.responseJSON.status === 'denied') {
                                Dialog
                                    .show('Удаление заказа', 'Не удалось удалить заказ. Удаление заблокировано.', Dialog.Buttons.Close)
                                    .attach(_this);
                            } else {
                                Dialog
                                    .show('Удаление заказа', 'Не удалось удалить заказ.', Dialog.Buttons.Close)
                                    .attach(_this);
                            }
                        }
                    });
                });
        },
        dispose: function() {
            if (this.disposed) { return; }

            this.destroyTooltip();

            View.prototype.dispose.apply(this, arguments);
        }
    });

    return TradeRequestNavbarView;
});

